<span><strong>{{label}}</strong></span>
<span class="dropdown" dropdown>
  <a dropdownToggle class="nav-link dropdown-toggle" [routerLink]="" queryParamsHandling="merge">
    <span class="navbar-brand text-uppercase">{{selected.name}}</span><span class="caret"></span>
  </a>
  <ul *dropdownMenu class="dropdown-menu bg-dark text-light dropdown-menu-right" role="menu">
    <li role="menuitem" *ngFor="let item of options" >
      <a class="dropdown-item text-secondary"
        (click)="onSelect(item)" >{{item.name}}
      </a>
    </li>
  </ul>
</span>
